@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.freeTextFields {
  height: 200px;
}

.visibility {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-bottom: $spacing-s;
}

.bannedFields {
  margin-top: -34px;
  margin-bottom: $spacing-m;
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.dropzone {
  height: 88px !important;
  width: 100%;
  align-self: center;
  flex-shrink: 0;
}

.selectDiscount {
  margin-bottom: $spacing-m;
}

.subtitle {
  font-size: $fontSize-xs;
}

.descriptionCard {
  margin-bottom: $spacing-s;
  border-radius: 12px !important;
}
